// analyticsApi.js
import { queryClient } from './queryClient';
import { getRequest } from './api';

/** Llamada directa al API sin caché (para que campaign_conversions_detail llegue siempre fresco). */
export async function fetchCombinedAnalyticsSummaryNoCache(
  start_date,
  end_date,
  brand_id,
  granularity = 'total',
  aggregation_level = 'campaign',
  platform = 'all',
  campaign_ids = null,
  conversion_ids = null,
  conversion_types = null
) {
  const params = { start_date, end_date, brand_id, granularity, aggregation_level, platform };
  if (campaign_ids && Array.isArray(campaign_ids) && campaign_ids.length > 0) {
    params.campaign_ids = campaign_ids.join(',');
  }
  if (conversion_ids && Array.isArray(conversion_ids) && conversion_ids.length > 0) {
    params.conversion_ids = conversion_ids.join(',');
  }
  if (conversion_types && Array.isArray(conversion_types) && conversion_types.length > 0) {
    params.conversion_types = conversion_types.join(',');
  }
  const response = await getRequest('/api/combined-analytics', {}, params);
  return response?.data ?? response;
}

async function fetchCombinedAnalyticsSummaryFn(
  start_date,
  end_date,
  brand_id,
  granularity = 'total',
  aggregation_level = 'campaign',
  platform = 'all',
  campaign_ids = null,
  conversion_ids = null,
  conversion_types = null
) {
  const params = { start_date, end_date, brand_id, granularity, aggregation_level, platform };
  if (campaign_ids && Array.isArray(campaign_ids) && campaign_ids.length > 0) {
    params.campaign_ids = campaign_ids.join(',');
  }
  if (conversion_ids && Array.isArray(conversion_ids) && conversion_ids.length > 0) {
    params.conversion_ids = conversion_ids.join(',');
  }
  if (conversion_types && Array.isArray(conversion_types) && conversion_types.length > 0) {
    params.conversion_types = conversion_types.join(',');
  }
  const response = await getRequest('/api/combined-analytics', {}, params);
  const data = response?.data ?? response;
  return data;
}

async function fetchExchangeRatesFn() {
  const { data } = await getRequest('/api/exchange-rates', {}, {});
  return data?.rates ?? { USD: 1 };
}

const analyticsApi = {
  fetchExchangeRates: async () => {
    return queryClient.ensureQueryData({
      queryKey: ['analytics', 'exchange-rates'],
      queryFn: fetchExchangeRatesFn,
    });
  },
  fetchCombinedAnalyticsSummary: async (
    start_date,
    end_date,
    brand_id,
    granularity = 'total',
    aggregation_level = 'campaign',
    platform = 'all',
    campaign_ids = null,
    conversion_ids = null,
    conversion_types = null
  ) => {
    return queryClient.ensureQueryData({
      queryKey: [
        'analytics',
        'combined-summary',
        start_date,
        end_date,
        brand_id,
        granularity,
        aggregation_level,
        platform,
        campaign_ids == null ? '' : (Array.isArray(campaign_ids) ? campaign_ids.join(',') : campaign_ids),
        conversion_ids == null ? '' : (Array.isArray(conversion_ids) ? conversion_ids.join(',') : conversion_ids),
        conversion_types == null ? '' : (Array.isArray(conversion_types) ? conversion_types.join(',') : conversion_types),
      ],
      queryFn: () =>
        fetchCombinedAnalyticsSummaryFn(
          start_date,
          end_date,
          brand_id,
          granularity,
          aggregation_level,
          platform,
          campaign_ids,
          conversion_ids,
          conversion_types
        ),
    });
  },
};

/** Evolución mensual de campañas SEARCH de Google Ads (tabla del panel Pristine). */
export async function fetchSearchEvolution(brand_id, months = 6) {
  const params = { brand_id, months };
  const response = await getRequest('/api/google-search-evolution', {}, params);
  return response?.data ?? response;
}

export default analyticsApi;